import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { formNarrowGridProps } from "@store/theme/common/props/form";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import * as React from "react";
import { css } from "styled-components";

const SearchBox = getWidgetComponent("MyLists/MyListsSearchBox");
const SortControl = getWidgetComponent("MyLists/MyListsSortControl");

export interface MyListsFiltersStyles {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    wrapper?: InjectableCss;
}

const styles: MyListsFiltersStyles = {
    gridContainer: {
        ...formNarrowGridProps,
        css: css`
            ${formNarrowGridProps.css}
            ${contentSpacingStyles()}
            @media print {
                display: none;
            }
        `,
    },
    gridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            display: block;
        `,
    },
};

export const myListsFiltersStyles = styles;

const MyListsFilters: React.FunctionComponent<WidgetProps> = () => {
    return (
        <GridContainer {...styles.gridContainer}>
            <GridItem {...styles.gridItem}>
                <SearchBox />
            </GridItem>
            <GridItem {...styles.gridItem}>
                <SortControl />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: MyListsFilters,
    definition: {
        group: "My Lists",
        displayName: "Filters",
        allowedContexts: ["MyListsPage"],
    },
};

export default widgetModule;
